var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStar = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 13",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 0C9.57 0 8.318.574 7.5 1.48 6.683.575 5.43 0 4.125 0 1.815 0 0 1.714 0 3.896c0 2.678 2.55 4.86 6.412 8.176L7.5 13l1.088-.935C12.45 8.756 15 6.575 15 3.896 15 1.714 13.185 0 10.875 0Zm-3.3 11.016-.075.071-.075-.07C3.855 7.962 1.5 5.943 1.5 3.896c0-1.417 1.125-2.48 2.625-2.48 1.155 0 2.28.701 2.678 1.672h1.402c.39-.97 1.515-1.672 2.67-1.672 1.5 0 2.625 1.063 2.625 2.48 0 2.047-2.355 4.066-5.925 7.12Z"
  })));
};
export { SvgStar as ReactComponent };